/**
 * Demo image fallbacks.
 *
 * The database (`products.cover_image`, Media Library URLs) is always the
 * primary source of truth. These bundled demo assets exist only so the
 * storefront never renders a broken image or an "unavailable" placeholder
 * while a product has no uploaded cover image yet (or its URL fails to load).
 */
import img1 from "@/assets/fragrance-1.jpg";
import img2 from "@/assets/fragrance-2.jpg";
import img3 from "@/assets/fragrance-3.jpg";
import img4 from "@/assets/fragrance-4.jpg";
import heroImg from "@/assets/hero-perfume.jpg";
import brandStoryImg from "@/assets/brand-story.jpg";
import collectionMen from "@/assets/collection-men.jpg";
import collectionWomen from "@/assets/collection-women.jpg";
import collectionUnisex from "@/assets/collection-unisex.jpg";
import imgCar from "@/assets/seed/car-perfume.jpg";
import imgDiffuser from "@/assets/seed/diffuser.jpg";
import imgHome from "@/assets/seed/home-aroma.jpg";
import imgRollOn from "@/assets/seed/roll-on.jpg";
import imgOil from "@/assets/seed/perfume-oil.jpg";
import imgSolid from "@/assets/seed/solid-perfume.jpg";
import imgSticks from "@/assets/seed/scented-sticks.jpg";
import imgFuture from "@/assets/seed/future-collection.jpg";

const PERFUMES = [img1, img2, img3, img4];

const CATEGORY_POOLS: Record<string, string[]> = {
  "personal-perfumes": PERFUMES,
  "car-perfumes": [imgCar, img3, img1],
  diffusers: [imgDiffuser, img2, img4],
  "home-office-diffusers": [imgHome, img1, img3],
  "roll-on-perfumes": [imgRollOn, img4, img2],
  "perfume-oils": [imgOil, img2, img4],
  "solid-perfumes": [imgSolid, img1, img3],
  "scented-sticks": [imgSticks, img4, img2],
  "future-collections": [imgFuture, img1, img2],
};

function hash(key: string): number {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return h;
}

/** Stable demo image for a product, keyed by slug/id and optional category. */
export function fallbackProductImage(key = "", categoryId?: string | null): string {
  const pool = (categoryId && CATEGORY_POOLS[categoryId]) || PERFUMES;
  return pool[hash(key) % pool.length];
}

const COLLECTION_COVERS = [collectionWomen, collectionMen, collectionUnisex, img1, img4];

/** Stable demo cover for a collection, keyed by slug/id. */
export function fallbackCollectionCover(key = ""): string {
  return COLLECTION_COVERS[hash(key) % COLLECTION_COVERS.length];
}

export const HERO_FALLBACK = heroImg;
export const BRAND_STORY_FALLBACK = brandStoryImg;
export const EDITORIAL_FALLBACK = collectionUnisex;